import $ from '@nuskin/nuskinjquery';
import angular from 'angular';
import moment from 'moment';
import Decimal from 'decimal.js';
import {AccountManager, UserService, AuthenticationService} from '@nuskin/ns-account';
import {
    BrowserDetection,
    events,
    NUSAnalytics,
    NsQuantityNotAvailable,
    NsNotQualifiedException,
    PersonalOfferStorageService,
    RunConfigService,
    ShoppingContext,
    SponsorStorageService,
    storage,
    StoreFrontSponsorStorageService,
    StringService,
    UrlService,
    util
} from '@nuskin/ns-util';
import {MySiteRestService} from '@nuskin/my-site-api';
// eslint-disable-next-line
import {ShopContextService, CartService, ErrorMessageCookieService, AdrService, AdrConstants, CurrencyService, SalesEventService} from '@nuskin/ns-shop';
// eslint-disable-next-line
import QualificationService from '@nuskin/exclusive-offer-sdk';
// eslint-disable-next-line
import {NsAdpAdd} from '@nuskin/ns-shop-elements';
// eslint-disable-next-line
// eslint-disable-next-line
import {NsSlottedDropdown} from '@nuskin/ns-form-elements';
import webLoyalty from '@nuskin/ns-loyalty-web';
import cartModule from '../cartModule.js';
import createLoyaltyHelperInstance from './../services/LoyaltyHelper.js';
import axios from 'axios';
import {getCachedConfigurations} from '@nuskin/configuration-sdk';
import {getStrings} from '../services/ContentstackStringsProvider.js';

const MAINTENANCE_BYPASS_KEY = 'maintenanceBypass';

cartModule.controller('CartCtrl', ['$scope', '$timeout', '$rootScope', '$location', 'nsDowntime', '$window', '$interpolate', 'nsAdrUtil', '$sce', '$filter',
    async function($scope, $timeout, $rootScope, $location, nsDowntime, $window, $interpolate, nsAdrUtil, $sce, $filter) {
        // Setup mobile native initializing flag..
        events.getValue(events.mobile.NATIVE_INITIALIZING, (status) => {
            $scope.nativeInitializing = !!status;
        }, false);

        const {Cart: cartCfg, Loyalty: loyaltyCfg} = getCachedConfigurations(['Cart', 'Loyalty']);
        $scope.cartCfg = cartCfg;
        $scope.loyaltyCfg = loyaltyCfg;

        const initHeader = async () => {
            /* ************************** set up header ************************ */
            $scope.personalOffer = PersonalOfferStorageService.getPersonalOffer();
            $scope.storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor();
            const {baseUrl, country, language} = RunConfigService.getRunConfig();
            const veraData = JSON.parse(localStorage.getItem('skin-consultation-vuex-state')) || {};
            const isCorporateSponsor = veraData.app && veraData.app.isCorporateSponsor;
            const appropriateContext = ShoppingContext.isContext(ShoppingContext.STOREFRONT) ||
                ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT) ||
                ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER) ||
                ShoppingContext.isContext(ShoppingContext.PRODUCT_OFFER);

            $scope.useMySiteFooterAndHeader = !isCorporateSponsor && appropriateContext;
            $scope.showHeader = !window.ReactNativeWebView && !cartCfg.hideHeader && $scope.useMySiteFooterAndHeader !== undefined;
            $scope.showFooter = !window.ReactNativeWebView && !cartCfg.hideFooter;

            // adjust header and footer if shopping context requires MySite(minimized) footer and footer
            if ($scope.useMySiteFooterAndHeader) {
                const sponsorId = await MySiteRestService.getCurrentSponsorId();
                // //adjust for MySite
                if (sponsorId) {
                    const subdomain = await MySiteRestService.getCurrentSubdomain();
                    $scope.storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor() || await MySiteRestService.getSponsorData(sponsorId);

                    if (ShoppingContext.isContext(ShoppingContext.STOREFRONT)) {
                        $scope.headerHrefOverride = `${UrlService.getAemLocaleUrl()}mysite/mysite-home.mysite.${subdomain}.html?storeId=${sponsorId}`;
                    }
                }

                $scope.distributorImage = $scope.storefrontSponsor
                    ? $scope.storefrontSponsor.siteLogo || $scope.storefrontSponsor.photoURL
                    : `${baseUrl}/content/dam/icons/logos/logo.png`;
            }

            // adjust for Vera
            if (ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT)) {
                $scope.headerHrefOverride = `${baseUrl}/static/skin-consultation/#/${language}_${country}/recommendations`;
            }

            // adjust for Personal(Product) Offer
            if ($scope.isPersonalOffer) {
                $scope.headerHrefOverride = $scope.personalOffer.landingPageURL;
                $scope.distributorImage = $scope.storefrontSponsor
                    ? $scope.storefrontSponsor.photoURL || $scope.storefrontSponsor.siteLogo
                    : `${baseUrl}/content/dam/icons/logos/logo.png`;
            }
            $scope.signOutUrl = $scope.headerHrefOverride || `${UrlService.getAemLocaleUrl}home.html`;
            /* ************************** end set up header ******************** */
        };

        const initCart = async () => {
            // If the locale in the route does not match what is in the runconfig then the
            // page needs to be reloaded. This can happen when the locale is change in the
            // route by hand.
            const runConfig = RunConfigService.getRunConfig();
            const [language, country] = UrlService.getLocaleFromUrl();
            if (language != runConfig.language || country != runConfig.country) {
                // This will likely be if the url does not have the locale on it which is likely
                // because the route is missing.  This will cause it to go to the last locale used.
                const locale = language && country ? `${language}_${country}` : `${runConfig.language}_${runConfig.country}`;
                window.location.hash = `#/${locale}/cart`;
                window.location.reload();
                return;
            }

            // Check to see if we need to clear ADR Override
            if (util.Url.getParam(window.location.href, 'orderReason') === 0) {
                AdrService.clearAdrOverride();
            }

            $scope.showCart = storage.getItem('receiving-items') !== true;
            if (!$scope.showCart) {
                return;
            }

            // If the user is not logged in and the url contain a #forceLogin, we need to display the login dialog.
            if (AccountManager.isLoggedIn() === null && window.location.href.indexOf('#forceLogin') > 0) {
                events.publish(events.authentication.REQUEST_FOR_LOGIN, {href: window.location.href});
            }

            // Set if in personal offer flow to hide search on cart
            $scope.isPersonalOffer = PersonalOfferStorageService.isPersonalOffer();

            const user = UserService.getUser(); // Don't remove this line when removing feature toggle
            let mixedCartNotAllowed = false;

            if (runConfig.assessmentApp) {
                $rootScope.hideMenuLeft = true;
            }

            await getStrings()
                .catch((err) => {
                    console.warn('unable to get translations from Contentstack', err);
                })
                .then((translations) => {
                    $scope.tdc = translations;
                    apply();
                });

            loadCustomJSStylesOnPage();
            $scope.runConfig = runConfig;
            $scope.error = ErrorMessageCookieService.getErrorMessages();
            $scope.continueDisabled = false;
            $scope.dispItems = [];
            $scope.cartInfo = CartService.getCartInfo();
            $scope.showPsv = ShopContextService.showPsv(getUserType(user));
            $scope.excludedBusFolioSkus = cartCfg.mixedCartExcludedSkus || [];
            $scope.cartReady = false;
            // This is for the spinner on /cart.html
            document.getElementById('earlySpinner').style.display = 'none';
            // This is for the spinner on /src/views/cart.html
            $scope.showCartSpinner = true;
            $scope.showCheckoutSpinner = false;
            $scope.showMinAdrPsvWarningModal = false;
            $scope.minAdrPsvWarningInModal = '';
            // $scope.showAvailablePoints = (AccountManager.isLoggedIn() && dispCfg.enablePointsRedemption && !runConfig.assessmentApp);
            $scope.showAvailablePoints = false;
            $scope.currencyCode = CurrencyService.getCurrency(runConfig.country).currencyCode;
            $scope.currencySymbol = CurrencyService.getCurrency(runConfig.country).symbol;
            $scope.currencyAccuracy = CurrencyService.getCurrency(runConfig.country).accuracy;
            $scope.currencyDecimalCharacter = CurrencyService.getCurrency(runConfig.country).decimal;
            $scope.adrStrings = null;
            $scope.adrLearnMorePopupOpen = false;

            const roundCurrency = (value) => {
                let precision = $scope.currencyAccuracy;
                if (!precision) {
                    precision = 2;
                }
                return parseFloat(value.toFixed(precision));
            };
            const toTruncatedNumString = (value) => {
                let precision = $scope.currencyAccuracy;
                if (!precision) {
                    precision = 2;
                }
                return new Decimal(value).toFixed(parseInt(precision));
            };
            const toTruncatedNumStringWithLocalizedDecimal = (value) => toTruncatedNumString(value).replace('.', $scope.currencyDecimalCharacter);

            $scope.loyaltyRewardsCreditAmount = {
                value: toTruncatedNumStringWithLocalizedDecimal(0.0)
            };
            $scope.loyaltyAdrRewardsCreditAmount = {
                value: toTruncatedNumStringWithLocalizedDecimal(0.0)
            };

            const {eid} = UserService.isLoggedIn() ? AccountManager.isLoggedIn() : {};
            $scope.eid = eid;

            if (cartCfg.showEventAdrFlow) {
                // In adr event flow these need to be true so the button is enabled and showing
                $scope.adrCheckComplete = true;
                $scope.isADREditable = true;
                $scope.showAdrDropdown = false;
            } else if (cartCfg.showAddToAdrDropdown) {
                $scope.showAdrDropdown = true;
            }

            $scope.$watch('cartInfo.totalOrderPrice', injectKlarnaMessage);

            if (loyaltyCfg.enabled) {
                $scope.translations = {
                    loyalty: {
                        'autoPointsAdjustmentMessage': '',
                        'orderNotEligibleToRedeem': 'Your order is not eligible to redeem loyalty points',
                        'earningsBannerExpiring': '',
                        'earningsWithPurchaseIncrement': '',
                        'earningsWithoutPurchaseIncrement': '',
                        'enjoyCreditsLabel': '',
                        'enjoyCreditsNonExpiringLabel': '',
                        'maintenanceNoticeCartWallet': '',
                        'learnHowLinkText': '',
                        'loyaltyPsvTbdTitle': '',
                        'onCompletionText': '',
                        'rewardsCreditsTitle': '',
                        'rewardsDisclaimer': '',
                        'rewardsLearnMoreButton': '',
                        'rewardsSummaryTitle': '',
                        'rewardsWalletExpiresLongTermBannerText': '',
                        'rewardsWalletExpiresLongTermViolator': '',
                        'rewardsWalletExpiresNeverViolator': '',
                        'rewardsWalletExpiresSoonDays': '',
                        'rewardsWalletExpiresSoonViolator': '',
                        'rewardsWalletExpiresThirtyBannerText': '',
                        'rewardsWalletExpiresThirtyViolator': '',
                        'rewardsWalletTitle': '',
                        'rewardsWalletTotalTitle': '',
                        'standardOrderRedeemBoxLabel': '',
                        'standardOrderSubtotalTitle': '',
                        'standardOrderSummaryTitle': '',
                        'subscriptionOrderRedeemBoxLabel': '',
                        'subscriptionSubtotalTitle': '',
                        'subscriptionSummaryTitle': '',
                        'subscriptionUseDisclaimer': '',
                        'toasterMinimumSpendMessage': '',
                        'toasterPurchaseIncrementMessage': '',
                        'useLoyaltyTitle': '',
                        'userTierNameT1': '',
                        'userTierNameT2': '',
                        'userTierNameT3': '',
                        'userTierNameT4': '',
                        'CUST.userTierNameT1': '',
                        'CUST.userTierNameT2': '',
                        'CUST.userTierNameT3': '',
                        'CUST.userTierNameT4': '',
                        'PREF.userTierNameT1': '',
                        'PREF.userTierNameT2': '',
                        'PREF.userTierNameT3': '',
                        'PREF.userTierNameT4': '',
                        'DIST.userTierNameT1': '',
                        'DIST.userTierNameT2': '',
                        'DIST.userTierNameT3': '',
                        'DIST.userTierNameT4': '',
                        'whatDoYouEnjoy': '',
                        'productRewardAvailable': '',
                        'productRewardRedeemable': '',
                        'productRewardEarnable': '',
                        'productRewardUnavailable': '',
                        'productBlueCoinSVGLocation': '',
                        'productGreenCoinSVGLocation': ''
                    }
                };

                getStrings()
                    .catch((err) => {
                        // console.warn('unable to get translations from Contentstack; using fallback', err);
                        return StringService.getApplicationStrings('loyalty');
                    })
                    .then((strings) => {
                        $scope.translations.loyalty = strings;
                        $scope.updatesevenBucketText();
                        apply();
                    });

                // angular.forEach($scope.translations, (object, applicationKey) => {
                //     StringService.getApplicationStrings(applicationKey).then((response) => {
                //         $scope.translations[applicationKey] = response;
                //         $scope.updatesevenBucketText();
                //         $scope.$apply();
                //     });
                // });

                $scope.loyalty_landing_page = loyaltyCfg.landingPage.replace(/\{locale\}/g, runConfig.language + '_' + runConfig.country);
                $scope.loyalty_dashboard_page = loyaltyCfg.dashboardPage.replace(/\{locale\}/g, runConfig.language + '_' + runConfig.country);

                $scope.redirectToRewardsLandingPage = () => {
                    window.location = $scope.loyalty_landing_page;
                };
            }

            $scope.hasLoyalty = () => {
                return loyaltyCfg.enabled &&
                        !loyaltyCfg.inMaintenanceMode &&
                        $scope.loyalty &&
                        $scope.loyalty.wallet;
            };

            $scope.calculateLoyaltyMaxRedeemAmount = () => {
                if ($scope.hasLoyalty()) {
                    CartService.getLoyaltyMaxRedeemAmount(false)
                        .then((amount) => {
                            if ($scope.loyaltyMaxRedeemAmount != amount) {
                                $scope.loyaltyMaxRedeemAmount = amount;
                                $scope.$digest();
                            }
                        });
                    CartService.getLoyaltyMaxRedeemAmount(true)
                        .then((amount) => {
                            if ($scope.loyaltyMaxAdrRedeemAmount != amount) {
                                $scope.loyaltyMaxAdrRedeemAmount = amount;
                                $scope.$digest();
                            }
                        });
                }
            };

            $scope.showAdrRedemption = () => {
                return createLoyaltyHelperInstance($scope).shouldShowAdrRedemption();
            };

            $scope.calculateLoyaltyRedeemAmountsIfApplicable = () => {
                if ($scope.hasLoyalty()) {
                    const orderMaxPointError = $scope.calculateLoyaltyRedeemAmount($scope.loyaltyRewardsCreditAmount.value, false);
                    const adrMaxPointError = $scope.calculateLoyaltyRedeemAmount($scope.loyaltyAdrRewardsCreditAmount.value, true);

                    $scope.loyalty.maxPointsError = orderMaxPointError || adrMaxPointError;
                }
            };

            if (loyaltyCfg.enabled && !loyaltyCfg.inMaintenanceMode) {
                CartService.loadLoyaltyPoints();
                // Forcing loyalty to refresh its data.
                webLoyalty.getRewardsPoints(true).then((loyaltyInfo) => {
                    $scope.loyalty = loyaltyInfo;
                    if (loyaltyInfo && UserService.isLoggedIn() && loyaltyInfo.optInStatus) {
                        $scope.loyaltyLoadFire();
                        apply();
                    }
                });

                events.subscribe(events.loyalty.LOYALTY_DATA_UPDATED, (_loyaltyInfo) => {
                    $scope.loyalty = _loyaltyInfo;

                    if (UserService.isLoggedIn() && _loyaltyInfo.optInStatus) {
                        $scope.loyaltyLoadFire();
                        apply();
                    }
                });

                $scope.loyaltyOptInAbility = false;

                $scope.parseContent = function(stringChange) {
                    return stringChange ? $interpolate(stringChange)($scope) : '';
                };
                $scope.sevenDayBucketText = [];

                $scope.updatesevenBucketText = () => {
                    if ($scope.loyalty && $scope.loyalty.buckets && $scope.loyalty.buckets.withinSeven &&
                        $scope.loyalty.buckets.withinSeven.length > 0) {
                        const sevenBucket = $scope.loyalty.buckets.withinSeven;

                        angular.forEach(sevenBucket, function(value, key) {
                            const expValue = {expiresInDays: value.expiresInDays};
                            const str = $interpolate($scope.translations.loyalty.rewardsWalletExpiresSoonDays);
                            $scope.sevenDayBucketText[key] = str(expValue);
                        });
                    }
                };

                webLoyalty.loyaltyCanOptIn().then((loyaltyCanOptInResponse) => {
                    $scope.loyaltyOptInAbility = loyaltyCanOptInResponse;
                    apply();
                });

                $scope.showPopover=true;

                // We need to modify the wallet size based on the view, so we set a max width on load, and call the function again on resize:
                $scope.setWalletMaxWidth = function() {
                    $('.rewardsWallet').css('max-width', ($('#rewards-display-content').width() + 20));
                };

                $(document).ready(function() {
                    $scope.setWalletMaxWidth();
                });

                angular.element($window).bind('resize', function() {
                    const vh = window.innerHeight * 0.01;
                    document.documentElement.style.setProperty('--vh', `${vh}px`);
                    $scope.setWalletMaxWidth();
                });

                $scope.loyaltyLoadFire = () => {
                    if (!$scope.loyalty) {
                        return;
                    }
                    const cartTotals = CartService.getCartInfo();
                    $scope.loyaltyToastMessage = true;

                    if ($scope.loyalty.userTier.purchaseRatio > 0) {
                        $scope.loyalty.tierInfo = (parseFloat($scope.loyalty.userTier.purchaseRatio * 100).toPrecision(2));
                    } else {
                        $scope.loyalty.tierInfo = '';
                    }

                    // This is to account for Annex sending a negative number for earned cap points
                    if ($scope.loyalty.user && $scope.loyalty.user.tier && $scope.loyalty.user.tier.completedLimitPoints) {
                        if (parseFloat($scope.loyalty.user.tier.completedLimitPoints) > parseFloat($scope.loyalty.user.tier.maximumLimitPoints)) {
                            // Don't show a value that is greater than the possible max
                            $scope.completedLimitPointsZeroUp = $scope.loyalty.user.tier.maximumLimitPoints;
                        } else {
                            // Set to zero if negative or just use the value
                            $scope.completedLimitPointsZeroUp = parseFloat($scope.loyalty.user.tier.completedLimitPoints) < 0 ||
                            !$scope.loyalty.user.tier.completedLimitPoints
                                ? 0 : parseFloat($scope.loyalty.user.tier.completedLimitPoints);
                        }
                    } else {
                        $scope.completedLimitPointsZeroUp = 0;
                    }


                    $scope.loyalty.currentOrderEarnings = CartService.calculateLoyaltyEarnings();

                    if ($scope.loyalty.userTier.purchaseIncrement > 0) {
                        $scope.amountToNextIncrement = CartService.calculateLoyaltyEarningsToNextIncrement();
                    }

                    // Difference in number of days
                    $scope.loyalty.soonestExpiring.daysToExpirationDate = moment(
                        moment($scope.loyalty.soonestExpiring.expirationDate, 'YYYY-MM-DD')).diff(moment().startOf('day'), 'days');

                    if (cartTotals.loyaltyRewardPoints > 0) {
                        $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(cartTotals.loyaltyRewardPoints);
                        $scope.loyaltyRewardsCreditAmountDisp = toTruncatedNumString(cartTotals.loyaltyRewardPoints);
                    } else {
                        $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    }

                    if (cartTotals.loyaltyAdrRewardPoints > 0) {
                        $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(cartTotals.loyaltyAdrRewardPoints);
                        $scope.loyaltyAdrRewardsCreditAmountDisp = toTruncatedNumString(cartTotals.loyaltyAdrRewardPoints);
                    } else {
                        $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    }

                    const handlePriceChange = async (context) => {
                        const hasAdrItems = !!$scope.cartInfo.totalAdrPrice;
                        const hasOrderItems = !!$scope.cartInfo.totalOrderPrice;
                        const redeemLimit = roundCurrency(
                            !hasAdrItems || !hasOrderItems
                                ? $scope.loyalty.userTier.redemptionLimit * $scope.cartInfo.loyaltyTotalRedeemPrice
                                : $scope.loyalty.userTier.redemptionLimit * $scope.cartInfo.loyaltyTotalRedeemPriceOrderItems
                        );

                        // clear point values if needed
                        let cartUpdates = {};
                        if (hasOrderItems || await CartService.getLoyaltyMaxRedeemAmount(true) == 0) {
                            $scope.cartInfo.loyaltyAdrRewards = false;
                            $scope.cartInfo.loyaltyAdrRewardPoints = 0.0;
                            $scope.loyaltyAdrRewardsCreditAmountDisp = 0.0;
                            cartUpdates = {
                                loyaltyAdrRewards: false,
                                loyaltyAdrRewardPoints: 0.0
                            };
                        }
                        if (hasAdrItems && !hasOrderItems || await CartService.getLoyaltyMaxRedeemAmount(false) == 0) {
                            $scope.cartInfo.loyaltyRewards = false;
                            $scope.cartInfo.loyaltyRewardPoints = 0.0;
                            $scope.loyaltyRewardsCreditAmountDisp = 0.0;

                            cartUpdates.loyaltyRewards = false;
                            cartUpdates.loyaltyRewardPoints = 0.0;
                        }
                        CartService.setCartProperties(cartUpdates, true);

                        // enforce the max limit
                        if (parseFloat($scope.cartInfo.loyaltyRewardPoints) + parseFloat($scope.cartInfo.loyaltyAdrRewardPoints) > redeemLimit) {
                            const maxPoints = toTruncatedNumString(parseFloat(redeemLimit));

                            if (!hasOrderItems) {
                                if ($scope.cartInfo.loyaltyAdrRewardPoints > redeemLimit) {
                                    $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(redeemLimit);
                                }
                                $scope.cartInfo.loyaltyAdrRewardPoints = redeemLimit;
                                $scope.loyaltyAdrRewardsCreditAmountDisp = maxPoints;

                                CartService.updateLoyaltyPoints(maxPoints, 'adr');
                            } else {
                                if ($scope.cartInfo.loyaltyRewardPoints > redeemLimit) {
                                    $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(redeemLimit);
                                }
                                $scope.cartInfo.loyaltyRewardPoints = redeemLimit;
                                $scope.loyaltyRewardsCreditAmountDisp = maxPoints;

                                CartService.updateLoyaltyPoints(maxPoints);
                            }
                            $scope.loyalty.maxPointsError = true;
                            events.publish(events.loyalty.LOYALTY_CART_MAX_LIMIT, {'context': 'cart'});
                        } else {
                            $scope.loyalty.maxPointsError = false;
                        }

                        // set our earnings
                        $scope.loyalty.currentOrderEarnings = CartService.calculateLoyaltyEarnings();

                        // set the amount to next increment
                        if ($scope.loyalty.userTier.purchaseIncrement > 0) {
                            $scope.amountToNextIncrement = CartService.calculateLoyaltyEarningsToNextIncrement();
                        }

                        // fire analytics
                        if (context == 'cartStandard') {
                            events.publish(events.loyalty.LOYALTY_CART_REC_SPEND_CHANGE, {
                                'context': 'cartStandard',
                                'cartTotal': $scope.cartInfo.totalOrderPrice,
                                'pointsEarned': $scope.loyalty.currentOrderEarnings,
                                'pointsToNextTier': $scope.amountToNextIncrement
                            });
                        }
                        if (context == 'cartSubscription') {
                            events.publish(events.loyalty.LOYALTY_CART_REC_SPEND_CHANGE, {
                                'context': 'cartSubscription',
                                'cartTotal': $scope.cartInfo.totalAdrPrice,
                                'pointsEarned': $scope.loyalty.currentOrderEarnings,
                                'pointsToNextTier': $scope.amountToNextIncrement
                            });
                        }

                        apply();
                    };

                    if ($scope.totalOrderPriceWatcher) {
                        $scope.totalOrderPriceWatcher();
                        $scope.totalOrderPriceWatcher = null;
                    }
                    $scope.totalOrderPriceWatcher = $scope.$watch('cartInfo.totalOrderPrice', () => handlePriceChange('cartStandard'));

                    if ($scope.totalAdrPriceWatcher) {
                        $scope.totalAdrPriceWatcher();
                        $scope.totalAdrPriceWatcher = null;
                    }
                    $scope.totalAdrPriceWatcher = $scope.$watch('cartInfo.totalAdrPrice', () => handlePriceChange('cartSubscription'));

                    $scope.calculateLoyaltyMaxRedeemAmount();
                };

                if (UserService.isLoggedIn() && $scope.loyalty && $scope.loyalty.optInStatus) {
                    $scope.loyaltyLoadFire();
                    apply();
                }


                if (loyaltyCfg.enabled && $scope.loyalty && $scope.loyalty.optInStatus !== undefined && $scope.loyalty.optInStatus != true) {
                    $scope.loyaltyToastMessage = ($scope.loyaltyToastMessage == false ? false : true);
                }

                $scope.removeLoyaltyMessage = function() {
                    $scope.loyaltyToastMessage = false;
                    events.publish(events.loyalty.LOYALTY_CART_TOAST_CLOSED, {'context': 'cart'});
                };

                $scope.rewardsChange = function() {
                    $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    CartService.toggleLoyaltyRewardPoints();
                    $scope.loyaltyAdrRewardsCreditAmountDisp = 0.0;
                    $scope.loyaltyRewardsCreditAmountDisp = 0.0;
                    $scope.loyalty.currentOrderEarnings = CartService.calculateLoyaltyEarnings();
                    $scope.loyalty.maxPointsError = false;
                    if ($scope.loyalty && $scope.loyalty.userTier.purchaseIncrement > 0) {
                        $scope.amountToNextIncrement = CartService.calculateLoyaltyEarningsToNextIncrement();
                    }
                    events.publish(events.loyalty.LOYALTY_CART_USE_REWARDS, {'context': 'cartStandard'});
                };

                $scope.rewardsAdrChange = function() {
                    $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(0);
                    CartService.toggleLoyaltyRewardPointsAdr();
                    $scope.loyaltyAdrRewardsCreditAmountDisp = 0.0;
                    $scope.loyaltyRewardsCreditAmountDisp = 0.0;
                    $scope.loyalty.currentOrderEarnings = CartService.calculateLoyaltyEarnings();
                    $scope.loyalty.maxPointsError = false;
                    if ($scope.loyalty && $scope.loyalty.userTier.purchaseIncrement > 0) {
                        $scope.amountToNextIncrement = CartService.calculateLoyaltyEarningsToNextIncrement();
                    }
                    events.publish(events.loyalty.LOYALTY_CART_USE_REWARDS, {'context': 'cartSubscription'});
                };

                $scope.calculateLoyaltyRedeemAmount = (requestedRedeemAmount, isAdr) => {
                    // this is to handle users in markets without loyalty or users in a loyalty market where they aren't loyalty eligible
                    if (!$scope.hasLoyalty()) {
                        return;
                    }

                    // calculate and default the requested redeem amount
                    requestedRedeemAmount = CurrencyService.parseCurrencyStringToFloat(requestedRedeemAmount.replace(/[^\d.,]/g, ''));
                    if (!requestedRedeemAmount) {
                        requestedRedeemAmount = 0.0;
                    }

                    const totalRedeemPrice = isAdr
                        ? CartService.getCartInfo().loyaltyTotalRedeemPrice : CartService.getCartInfo().loyaltyTotalRedeemPriceOrderItems;

                    // cap that requested redeem amount to the max allowed
                    const actualRedeemAmount = Math.min(
                        requestedRedeemAmount,
                        $scope.loyalty.wallet.available,
                        roundCurrency($scope.loyalty.userTier.redemptionLimit * totalRedeemPrice)
                    );

                    // notify that the redeem amount was updated
                    events.publish(events.loyalty.LOYALTY_CART_REWARDS, {
                        context: 'cart',
                        priorAmount: CartService.getCartInfo().loyaltyRewardPoints,
                        newAmount: actualRedeemAmount
                    });

                    // notify if a number above the max was requested
                    const maxPointsError = actualRedeemAmount < requestedRedeemAmount;
                    if (maxPointsError) {
                        events.publish(events.loyalty.LOYALTY_CART_MAX_LIMIT, {'context': 'cart'});
                    }

                    // use the new redeem amount to update our values both in the view and in CartService
                    if (isAdr) {
                        $scope.loyaltyAdrRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(actualRedeemAmount);
                        $scope.loyaltyAdrRewardsCreditAmountDisp = actualRedeemAmount;
                        CartService.updateLoyaltyPoints(actualRedeemAmount, 'adr');
                    } else {
                        $scope.loyaltyRewardsCreditAmount.value = toTruncatedNumStringWithLocalizedDecimal(actualRedeemAmount);
                        $scope.loyaltyRewardsCreditAmountDisp = actualRedeemAmount;
                        CartService.updateLoyaltyPoints(actualRedeemAmount);
                    }

                    $scope.loyalty.currentOrderEarnings = CartService.calculateLoyaltyEarnings();
                    if ($scope.loyalty.userTier.purchaseIncrement > 0) {
                        $scope.amountToNextIncrement = CartService.calculateLoyaltyEarningsToNextIncrement();
                    }

                    $scope.calculateLoyaltyMaxRedeemAmount();
                    return maxPointsError;
                };

                $scope.calculateLoyaltyMaxRedeemAmount();

                $scope.rewardsCreditAmountUsageChange = function(e) {
                    $scope.calculateLoyaltyRedeemAmountsIfApplicable();
                };

                $scope.rewardsCreditAmountUsageChangeAdr = function(e) {
                    $scope.calculateLoyaltyRedeemAmountsIfApplicable();
                };

                $scope.canEarnRewards = function() {
                    return ($scope.loyalty && $scope.loyalty.userTier.purchaseRatio > 0) ? true : false;
                };

                $scope.userReachedCap = function() {
                    return ($scope.loyalty &&
                      $scope.loyalty.user &&
                      $scope.loyalty.user.tier &&
                      $scope.loyalty.user.tier.maximumLimitPoints &&
                      $scope.loyalty.user.tier.completedLimitPoints &&
                      parseFloat($scope.loyalty.user.tier.completedLimitPoints) >= parseFloat($scope.loyalty.user.tier.maximumLimitPoints)
                    ) ? true : false;
                };

                $scope.userReachedCapOnOrder = function() {
                    // Check if current order is over cap
                    if ($scope.loyalty &&
                      $scope.loyalty.user &&
                      $scope.loyalty.user.tier) {
                        const completedLimitPoints = !$scope.loyalty.user.tier.completedLimitPoints ? 0 : $scope.loyalty.user.tier.completedLimitPoints;
                        return $scope.loyalty.user.tier.maximumLimitPoints &&
                            $scope.loyalty.currentOrderEarnings &&
                            (parseFloat(completedLimitPoints) >= parseFloat($scope.loyalty.user.tier.maximumLimitPoints) ||
                                parseFloat(completedLimitPoints) + parseFloat($scope.loyalty.currentOrderEarnings) >=
                                parseFloat($scope.loyalty.user.tier.maximumLimitPoints));
                    } else {
                        return false;
                    }
                };

                $scope.tierHasPointsEarnedCap = function() {
                    // Check for the max cap on the tier
                    return $scope.loyalty &&
                      $scope.loyalty.user &&
                      $scope.loyalty.user.tier &&
                      $scope.loyalty.user.tier.maximumLimitPoints;
                };

                $scope.toggleLoyaltyWallet = function() {
                    $scope.showWalletPopover = !$scope.showWalletPopover;
                    events.publish(events.loyalty.LOYALTY_CART_WALLET_HOVER, {'context': 'cart'});
                };

                $scope.walletAmountHover = function() {
                    events.publish(events.loyalty.LOYALTY_CART_WALLET_HOVER, {'context': 'cart'});
                };

                $scope.learnToIncreaseClick = function() {
                    events.publish(events.loyalty.LOYALTY_LEARN_INCREASE, {'context': 'cart'});
                };
            }

            // COM-2043: GA Checkout Step 1 to fire after adding item to cart
            publishCartCheckoutEvent(1, $scope.dispItems);

            $scope.flags = {
                cartBusy: false
            };

            // image urls
            $scope.spinner = RunConfigService.getBaseUrl(false) + '/content/dam/apps/checkout/spinner.gif';
            $scope.iconSpinner = RunConfigService.getBaseUrl(false) + '/content/dam/apps/checkout/icon-spinner.gif';
            $scope.iconExpandLess = RunConfigService.getBaseUrl(false) + '/apps/shop/components/shop/cart/images/icon_expand_less_24px.svg';

            if ($scope.tdc.minPSVWarningCheckoutBtnTxt) {
                $scope.minPSVWarningCheckoutBtn = $scope.tdc.minPSVWarningCheckoutBtnTxt;
            } else {
                $scope.minPSVWarningCheckoutBtn = 'Checkout';
            }

            if ($scope.tdc.minPSVWarningContinueBtnTxt) {
                $scope.minPSVWarningContinueBtn = $scope.tdc.minPSVWarningContinueBtnTxt;
            } else {
                $scope.minPSVWarningContinueBtn = 'Continue Shopping';
            }

            $scope.emptyCartCta = function() {
                events.publish(events.shop.EMPTY_CART_CTA);
                if (ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT)) {
                    window.location = $scope.headerHrefOverride;
                } else if ($scope.isPersonalOffer) {
                    window.location = $scope.personalOffer.landingPageURL;
                } else {
                    if ($scope.storefrontSponsor) {
                        window.location = $scope.headerHrefOverride;
                    } else {
                        window.location = `${UrlService.getAemLocaleUrl()}home.html`;
                    }
                }
            };

            $scope.toggleModal = function() {
                $scope.modalShown = !$scope.modalShown;
            };

            $scope.toggleShowMoreInfo = function($event, dispItem) {
                $event.preventDefault();
                if (!runConfig.assessmentApp) {
                    dispItem.showMoreInfo = !dispItem.showMoreInfo;
                }
            };

            $scope.toggleShowBpOptions = function($event, dispItem) {
                $event.preventDefault();
                if (!runConfig.assessmentApp) {
                    dispItem.showBpOptions = !dispItem.showBpOptions;
                }
            };

            $scope.mouseClicked = function(event) {
                // this gets called if the document gets a click. Hides
                //  the search results div
                if (event && event.target &&
                    event.target.id != 'productSearch' &&
                    event.target.id != 'productAutoComplete' &&
                    $(event.target).parents('#productAutoComplete').length == 0 &&
                    $(event.target).parents('#productSearch').length == 0) {
                    events.publish(events.shop.PRODUCT_SEARCH_CLEAR);
                    apply();
                }
            };

            $scope.learnMoreLinkClickHandler = function() {
                $scope.adrLearnMorePopupOpen = !$scope.adrLearnMorePopupOpen;
            };

            $scope.removeProductClicked = function(index, dispItem, $event) {
                // In IE10 the enter key can incorrectly trigger this event,
                // so we need to verify that the mouse is actually over the button.
                // The event type is "click", even though it was triggered by "enter"
                const mousePosition = {x: $event.pageX, y: $event.pageY};
                let isValid = true;
                // eslint-disable-next-line
                if (BrowserDetection.IECompatabilityVersion() <= 10) {
                    isValid = $event && util.isPositionWithinElement(mousePosition, $event.target);
                }
                if (isValid) {
                    $scope.error.clearErrors();
                    CartService.removeItemByKey(dispItem.key);

                    if (runConfig.assessmentApp && $scope.dispItems.length === 0) {
                        window.location = runConfig.assessmentPurchase;
                    }
                }
                $scope.calculateLoyaltyRedeemAmountsIfApplicable();

                // COM-2043: GA Checkout Step 1 to fire after removing product from cart
                publishCartCheckoutEvent(1, $scope.dispItems);
            };

            $scope.isAdrOverride = function() {
                return AdrService.isAdrOverride();
            };

            $scope.gotoAdrPackagesPage = function() {
                $scope.gotoPage(cartCfg.adrPackagesPage);
            };

            $scope.gotoFastStartPackagesPage = function() {
                $scope.gotoPage(cartCfg.fastStartPackagesPage);
            };

            $scope.disableAdrButton = function() {
                return !$scope.adrCheckComplete ||
                    $scope.dispItems.length === 0 ||
                    (!$scope.isADREditable) ||
                     (!$scope.isADRVersion3 && cartCfg.enableAddForADRVersion3Only);
            };

            $scope.disableEventAdrButton = function() {
                return $scope.dispItems.length === 0 || (!$scope.isADREditable) || (!$scope.isADRVersion3 && cartCfg.enableAddForADRVersion3Only);
            };

            $scope.showPayPalBtn = () => {
                return cartCfg.enablePayPalButton &&
                    ($scope.hasOrderItems ||
                    AdrService.isAdrOverride());
            };

            $scope.showPayPalTxt = () => {
                return cartCfg.enablePayPalText &&
                    ($scope.hasOrderItems ||
                    AdrService.isAdrOverride());
            };

            $scope.showKlarnaTxt = () => {
                return cartCfg.showKlarna && $scope.hasOrderItems && !AdrService.isAdrOverride();
            };

            $scope.showAdrBtn = function() {
                let show = true;
                if ($scope.dispItems.length === 1 && $scope.dispItems[0].isBusinessPortfolio) {
                    // Hide the Add to Existing ADR button if a business portfolio is the only item in the cart.
                    show = false;
                }
                if (isColdGuest()) {
                    show = false;
                }
                return (!runConfig.assessmentApp &&
                    cartCfg.showAddToExistingAdr &&
                    !cartCfg.showEventAdrFlow &&
                    $scope.isADREditable &&
                    !AdrService.isAdrOverride() &&
                    ($scope.hasExistingAdr || !$scope.adrCheckComplete) &&
                    window.location.hostname.indexOf('mynuskin.com') < 0 &&
                    show);
            };

            $scope.showEventAdrBtn = function() {
                let show = true;
                if (isColdGuest()) {
                    show = false;
                }

                return (show && user && user.id && !runConfig.assessmentApp &&
                    cartCfg.showEventAdrFlow &&
                    !AdrService.isAdrOverride() &&
                    !$scope.eventAdrBtnClicked &&
                    window.location.hostname.indexOf('mynuskin.com') < 0 &&
                    !$scope.showAdrDropdown &&
                    (cartCfg.showAddToExistingAdr || cartCfg.showAddToAdrDropdown)
                );
            };

            $scope.showNumAdrTxt = () => {
                return (user && user.id && !$scope.hasExistingAdr &&
                    cartCfg.showEventAdrFlow && $scope.numAdrsTxt);
            };

            $scope.getContinueBtnTxt = function() {
                if ($scope.hasAdrItems) {
                    return $scope.tdc.adrContinueTxt;
                } else {
                    return $scope.tdc.orderContinueTxt;
                }
            };

            $scope.doCartContinueAction = function(paymentType = 'default') {
                storage.setItem(storage.metadata.PAYMENT_PREF, paymentType);
                if ($scope.flags.cartBusy) {
                    $timeout(function() {
                        $scope.doCartContinueAction();
                    }, 100);
                } else {
                    cartContinue();
                }
            };

            $scope.overrideCancelAction = () => {
                const page = $scope.tdc.cancelADROverridePath;

                AdrService.clearAdrOverride(); // Clear Adr Override context
                CartService.clearCart(); // Clear the view of the cart items

                const timer = setInterval(() => {
                    if (!storage.getItem('pcActivity')) {
                        clearInterval(timer);
                        window.location.href = page + (page.endsWith('.html') ? '' : '.html');
                    }
                }, 20);
            };

            $scope.getLineItemClass = function(item) {
                if (item.isAdr) {
                    return 'adrRow';
                }
                return 'noAdrRow';
            };

            $scope.adrBtnClick = function() {
                const bpDispItem = $scope.dispItems.find((dispItem) => dispItem.isBusinessPortfolio);

                if (bpDispItem) {
                    CartService.removeItemByKey(bpDispItem.key);
                }
                if ($scope.hasAdrItems) {
                    AdrService.initAdrDraft();
                } else {
                    AdrService.deleteAdrDraft();
                }
                window.location = `${UrlService.getAemLocaleUrl()}shop.adr-select.html`;
            };

            /**
             * adrBtnClick will either take the user to adr manage
             * or show the adr list dropdown if the config is enabled
             */
            $scope.adrEventBtnClick = function() {
                $scope.eventAdrBtnClicked = true;
                $scope.adrCheckComplete = false;
                const promise = getAdrs(user);
                if (cartCfg.showAddToExistingAdr) {
                    promise.then((response) => {
                        if ($scope.isADREditable && $scope.hasExistingAdr && !(!$scope.isADRVersion3 && cartCfg.enableAddForADRVersion3Only)) {
                            const bpDispItem = $scope.dispItems.find((dispItem) => dispItem.isBusinessPortfolio);

                            if (bpDispItem) {
                                CartService.removeItemByKey(bpDispItem.key);
                            }
                            if ($scope.hasAdrItems) {
                                AdrService.initAdrDraft();
                            } else {
                                AdrService.deleteAdrDraft();
                            }
                            window.location = `${UrlService.getAemLocaleUrl()}shop.adr-select.html`;
                        }
                    });
                } else if (cartCfg.showAddToAdrDropdown) {
                    $scope.showAdrDropdown = true;
                }
            };

            $scope.showAdrOption = function() {
                // We want to add something here to turn it on or off if we are in my store/my site/skin consult:
                const isSkinConsult = util.isSkinConsult ? util.isSkinConsult() : false;
                if (($scope.storefrontSponsor || isSkinConsult) && cartCfg.mySiteHideAdr) {
                    return false;
                }

                return cartCfg.showCartAdrCheckBox && !runConfig.assessmentApp;
            };

            $scope.showMixedCartModal = function() {
                return mixedCartNotAllowed && $scope.hasOrderItems && $scope.hasAdrItems;
            };

            $scope.gotoPage = function(page) {
                window.location = page;
            };

            $scope.cancelMinAdrPsvModal = function() {
                $scope.showMinAdrPsvWarningModal = false;
            };

            $scope.cancelMixedCartModal = function() {
                mixedCartNotAllowed = false;
            };

            $scope.qtyChanged = function(dispItem) {
                const requestedQty = dispItem.qty;

                CartService.changeItemQty(dispItem, parseInt(dispItem.qty), 'increase cart quantity')
                    .catch((err) => {
                        if (err instanceof NsNotQualifiedException) {
                            events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {'sku': dispItem.sku});
                        } else if (err instanceof NsQuantityNotAvailable) {
                            showQtyAvailablityError(requestedQty);
                        } else {
                            console.error(err);
                        }
                        // reset the item qty back to what it was.
                        dispItem.qty = CartService.getItemData().find((item) => item.key === dispItem.key).qty;
                        apply();
                    });
            };

            $scope.decrementQty = function(dispItem, $event) {
                if ($scope.qtyDisabled(dispItem)) return;

                if (dispItem.qty > 1) {
                    CartService.changeItemQty(dispItem, dispItem.qty - 1)
                        .then(() => {
                            // COM-2043: GA Checkout Step 1 to fire after removeFromCart Event
                            publishCartCheckoutEvent(1, $scope.dispItems);
                        })
                        .catch((err) => {
                            if (err instanceof NsNotQualifiedException) {
                                events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {'sku': dispItem.sku});
                            } else if (err instanceof NsQuantityNotAvailable) {
                                showQtyAvailablityError(dispItem.qty - 1);
                            } else {
                                console.error(err);
                            }
                            apply();
                        });
                }

                if ($event) {
                    $event.target.blur();
                }

                $scope.calculateLoyaltyRedeemAmountsIfApplicable();
            };

            $scope.incrementQty = function(dispItem, referrer, $event) {
                if ($scope.qtyDisabled(dispItem)) return;

                if (dispItem.qty < 999) {
                    CartService.changeItemQty(dispItem, dispItem.qty + 1, referrer)
                        .then(() => {
                            // COM-2043: GA Checkout Step 1 fires after addToCart Event
                            publishCartCheckoutEvent(1, $scope.dispItems);
                            $scope.calculateLoyaltyMaxRedeemAmount();
                        })
                        .catch((err) => {
                            if (err instanceof NsNotQualifiedException) {
                                events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {'sku': dispItem.sku});
                            } else if (err instanceof NsQuantityNotAvailable) {
                                showQtyAvailablityError(dispItem.qty + 1);
                            } else {
                                console.error(err);
                            }
                            apply();
                        });
                }

                if ($event) {
                    $event.target.blur();
                }

                NUSAnalytics.setProductDTM(dispItem.sku, dispItem.qty, (dispItem.price * dispItem.qty));
            };

            $scope.checkQtyValue = function(dispItem) {
                let qty = dispItem.qty;

                qty = qty.replace(/\D/g, '');
                if (qty.length > 3) {
                    qty = qty.substring(0, 3);
                }

                dispItem.qty = qty;
            };

            $scope.qtyDisabled = function(dispItem) {
                return dispItem.isBusinessPortfolio;
            };

            $scope.qtyPointsLabel = function(dispItem) {
                const qtyRedeemWithPoints = $scope.tdc.qtyRedeemWithPoints || $scope.qtyRedeemWithPoints;
                return qtyRedeemWithPoints.replace('{num}', dispItem.qtyRedeemWithPoints);
            };

            $scope.showRedeemValue = function(item) {
                return (item.redeem && !item.partialRedeem);
            };

            $scope.canAddAsAdr = function(item) {
                return item && item.indexOf('addAsAdrLink') >= 0;
            };

            $scope.addItemAsAdr = function(item) {
                const itemParts = item.split(':');

                // Make sure we have a sku to add
                if (itemParts.length > 1) {
                    CartService.addSkuToCart({
                        sku: itemParts[1],
                        userId: user ? user.id : undefined,
                        cntryCd: runConfig.country,
                        language: runConfig.language,
                        qty: 1,
                        region: runConfig.country === 'CA' ? getUserRegion(user) : undefined,
                        adrOnly: true,
                        isAdr: true,
                        referrer: 'adr'
                    }).finally(() => {});
                }
            };

            $scope.adrStatusChanged = function(itemKey) {
                CartService.toggleItemAdrStatus(itemKey, cartCfg.adrSelectAll);

                $scope.calculateLoyaltyRedeemAmountsIfApplicable();
                events.publish(events.shop.ADR_STATUS_CHANGE);
            };

            $scope.changeBpItem = function(dispItem, altBpSku) {
                CartService.changeBpItem(altBpSku);
            };

            $scope.inSignupMode = function() {
                return CartService.inSignupMode();
            };

            $scope.isLoggedIn = function() {
                return UserService.isLoggedIn();
            };

            /**
             * Testing if cart is running in webview
             * @return {boolean}
             */
            $scope.isWebview = function() {
                if (window.ReactNativeWebView) {
                    return true;
                }
                return false;
            };

            /**
             * Checking to see if link should be shown
             * @return {boolean}
             */
            $scope.showLearnMoreLink = function() {
                if (window.ReactNativeWebView || $scope.isPersonalOffer || SponsorStorageService.getSponsor()) {
                    return false;
                }
                return true;
            };

            /**
             * showQtyAvailablityError
             *
             * @param {number} requestedQty
             */
            function showQtyAvailablityError(requestedQty) {
                $scope.error.clearErrors();
                $scope.error.addErrorMessage('error', {text: $scope.tdc.qtyChangedAtpErrorTxt.replace('{qty}', requestedQty)});
            }

            /**
             * This checks the case where there might be multiple tabs with a different
             *   user logged in in the second tab.  If the first tab then hits continue
             *   on the cart we need to prevent it from going on.
             *
             * @return {boolean}
             */
            function checkUser() {
                const thisUserId = user ? user.id : null;
                const storedUser = UserService.getUser();
                const storedUserId = storedUser ? storedUser.id : null;

                if (storedUserId != thisUserId) {
                    CartService.clearCart();
                    CartService.goToCartPage();
                }
                return true;
            }

            /**
             * cartContinue
             */
            function cartContinue() {
                // checkUser();
                $scope.error.clearErrors();
                $scope.hasAdrItems && !AdrService.isAdrOverride() ? AdrService.initAdrDraft() : AdrService.deleteAdrDraft();

                if (continueConditionsOk()) {
                    if (AccountManager.isLoggedIn() || (cartCfg.allowAnonymousShopping && util.getSponsorId())) {
                        gotoNextPage();
                    } else {
                        if (window.ReactNativeWebView) {
                            window.ReactNativeWebView.postMessage(JSON.stringify({name: 'need_to_signin', payload: true}));
                        } else {
                            if (cartCfg.newSignInUponCheckout) {
                                // Note:  We haven't  reached to a conslusion yet if we have to use wrapper for guest checkout.
                                // if it is indeed there's a need of a wrapper, then we use event just like what we have with  oktalogin
                                window.location = '/static/guest-checkout/';
                            } else {
                                events.publish(events.authentication.REQUEST_FOR_LOGIN, {href: window.location.href});
                            }
                        }
                    }
                }
            }

            /**
             * gotoNextPage
             */
            function gotoNextPage() {
                if (window.ReactNativeWebView) {
                    $scope.showCheckoutSpinner = true;
                    apply();
                }
                $scope.continueDisabled = true;
                SalesEventService.checkForWaits().then(function() {
                    if (runConfig.assessmentApp) {
                        $location.path('/orderSummary');
                    } else {
                        // Note: this doesn't seem to be coming through to meCommerece.
                        // COM-2043: On click of purchase on cart page fire checkout event, step 2
                        publishCartCheckoutEvent(2, $scope.dispItems);
                        if (!AccountManager.isLoggedIn() && SponsorStorageService.getSponsor()) {
                            runConfig.landing = CartService.getCartPage({isMySite: true});
                            RunConfigService.setRunConfig(runConfig);
                            const configGuestUrl = cartCfg.mysiteGuestSignupPage ||
                                'shopper-account.mysite.html#/guestSignup';
                            window.location = `${UrlService.getAemLocaleUrl()}${configGuestUrl}`;
                        } else {
                            let isMySite = false;
                            if ($scope.storefrontSponsor || SponsorStorageService.getSponsor()) {
                                // Set the landing page to cart.mysite.html so checkout can redirect back to the correct cart in error cases
                                isMySite = true;
                            }
                            runConfig.landing = CartService.getCartPage({isMySite});
                            RunConfigService.setRunConfig(runConfig);

                            nsAdrUtil.showAdrShipWhen().then((showShipWhen) => {
                                CartService.goToCheckoutPage({route: `${showShipWhen ? 'adrShipWhen' : 'orderSummary'}`, isMySite});
                            }).catch((err) => {
                                console.error(err);
                            });
                        }
                    }
                });
            }

            /**
             * getUserRegion
             *
             * @param {object} user
             * @return {string|*}
             */
            function getUserRegion(user) {
                if (user && user.shipTo && user.shipTo.country === 'CA') {
                    return user.shipTo.region;
                }
                return '';
            }

            /**
             * checks to see if the user is a guest and not a personal offer or mysite guest
             * @return {boolean}
             */
            function isColdGuest() {
                const isSkinConsult = util.isSkinConsult ? util.isSkinConsult() : false;
                return user && user.isGuest && !$scope.storefrontSponsor && !isSkinConsult;
            }

            /**
             * continueConditionsOk
             *
             * @return {boolean}
             */
            function continueConditionsOk() {
                let msg = '';
                let retVal = true;

                if (isColdGuest() && $scope.hasAdrItems) {
                    $scope.error.errorMessages.push({text: $scope.tdc.guestAdrNotAllowed});
                    return false;
                }

                // Check to see if we can have a mixed cart
                if (cartCfg.adrSelectAll && $scope.hasAdrItems && $scope.hasOrderItems) {
                    mixedCartNotAllowed = true;
                    retVal = false;
                } else if (cartCfg.minAdrPsvCheck === 'warning') { // check min PSV for ADR
                    // if coming from warning popup then continue
                    if (!$scope.showMinAdrPsvWarningModal && !CartService.minAdrPsvMet()) {
                        $scope.minAdrPsvWarningInModal = $scope.tdc.minPsvWarningTxt.replace(/\{minPsv\}/g, cartCfg.minAdrPsv);
                        $scope.showMinAdrPsvWarningModal = true;
                        retVal = false;
                    } else {
                        $scope.showMinAdrPsvWarningModal = false;
                    }
                } else if (cartCfg.minAdrPsvCheck === 'block') {
                    if (!CartService.minAdrPsvMet()) {
                        msg = $scope.tdc.minPsvErrorTxt.replace(/\{minPsv\}/g, cartCfg.minAdrPsv);
                        $scope.error.errorMessages.push({text: msg});
                    }
                    retVal = $scope.error.errorMessages.length === 0;
                }

                return retVal;
            }

            /**
             * checkForDowntime
             */
            function checkForDowntime() {
                // Skip the downtime check if the bypass is set in session storage
                if (!sessionStorage.getItem(MAINTENANCE_BYPASS_KEY)) {
                    // Check for downtime
                    nsDowntime.getDowntime(`${$scope.runConfig.language}_${$scope.runConfig.country}`).then(function() {
                        if (nsDowntime.isDown()) {
                            CartService.goToCheckoutPage({route: 'downtime'});
                        } else {
                            const goingDownInMin = nsDowntime.isGoingDownSoon();
                            if (goingDownInMin > 0) {
                                getStrings()
                                    .then((translations) => translations.downtimeText)
                                    .catch((err) => {
                                        // console.warn('unable to get translations from Contentstack; using fallback', err);
                                        return StringService.getString('downtimeText', 'Shopping is going down for maintenance soon');
                                    })
                                    .then((downtimeText) => {
                                        $scope.error.addErrorMessage('info', {
                                            text: downtimeText.replace('{0}', goingDownInMin),
                                            details: ''
                                        });
                                    });
                            }
                        }
                    });
                }
            }

            /**
             * showAdrOverrideInfo
             */
            function showAdrOverrideInfo() {
                if (AdrService.isAdrOverride()) {
                    $scope.cartTitle = $scope.tdc.adrOverrideHeader;
                } else {
                    $scope.cartTitle = $scope.tdc.cartHeader;
                }
            }


            /**
             * apply
             *
             * @param {function} _callback
             */
            function apply(_callback) {
                const callback = _callback || function() {};

                if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                    $scope.$apply(callback);
                    window.sessionStorage.removeItem('nstoast-allowed');
                } else {
                    callback();
                }
            }

            /**
             * getAgelocCodes
             *
             * @return {string}
             */
            function getAgelocCodes() {
                let codes = '';
                let dispItem;

                for (let i = 0; i < $scope.dispItems.length; i++) {
                    dispItem = $scope.dispItems[i];
                    if (dispItem.isAgelocme.isAgelocme) {
                        if (codes.length > 0) {
                            codes += ', ';
                        }
                        codes += dispItem.agelocme.code;
                    }
                }
                return codes;
            }

            /**
             * getAdrs
             *
             * @param {object} user
             * @return {Promise<any>}
             */
            function getAdrs(user) {
                const promise = new Promise((resolve, reject) => {
                    $scope.adrCheckComplete = false;
                    if ((cartCfg.showAddToExistingAdr || cartCfg.showAddToAdrDropdown || runConfig.assessmentApp) && user && user.id) {
                        AdrService.getAdrList({
                            context: 'cart'
                        }).then((list) => {
                            setAdrFlags(list);
                            hideShowAdrTip();
                            resolve();
                        }).catch(() => {
                            $scope.hasExistingAdr = false;
                            $scope.adrCheckComplete = true;
                            reject(new Error('Error'));
                        });
                    } else {
                        $scope.adrCheckComplete = true; // If no one is logged in enable continue and turn off adr check spinner
                        resolve();
                    }
                });
                return promise;
            }

            /**
             * setAdrFlags
             *
             * @param {array} adrList
             */
            function setAdrFlags(adrList) {
                if (cartCfg.enableAddForADRVersion3Only) {
                    adrList = removeARO1FromList(adrList);
                }
                $scope.hasExistingAdr = (adrList.length > 0);
                $scope.numAdrsTxt = $scope.tdc.numAdrsTxt !== undefined ? $scope.tdc.numAdrsTxt.replace('{numAdrs}', adrList.length) : '';
                $scope.adrCheckComplete = true; // Enable continue and turn off adr check spinner
                $scope.isADRVersion3 = false;
                $scope.isADREditable = true;

                if (adrList.length === 1) {
                    if (isARO3(adrList[0])) {
                        $scope.isADRVersion3 = true;
                        $scope.isADREditable = adrList[0].Editable === true;
                    }
                }

                if (runConfig.assessmentApp) {
                    events.publish(events.shop.AGELOC_ADR_INIT, {adrs: adrList, codeInCart: getAgelocCodes()});
                }

                // Force the above $scope variables to update in the UI
                if (!$scope.$$phase) {
                    apply();
                }
            }

            /**
             * isARO3
             *
             * @param {object} aro
             * @return {boolean}
             */
            function isARO3(aro) {
                if (typeof aro !== 'undefined' &&
                    Object.prototype.hasOwnProperty.call(aro, 'SalesOrderDetail') &&
                    Object.prototype.hasOwnProperty.call(aro.SalesOrderDetail, 'Custom') &&
                    (aro.SalesOrderDetail.Custom instanceof Array) &&
                    Object.prototype.hasOwnProperty.call(aro.SalesOrderDetail.Custom[0], 'Value')) {
                    const value = aro.SalesOrderDetail.Custom[0].Value;
                    // We should use ADRConstants however its part of a huge client lib that is not included in cart.
                    if (value.length > 0 && (value !== AdrConstants.HK20 || value.toLowerCase() === AdrConstants.HK_ageLoc_Loyalty)) {
                        return true;
                    }
                }
                return false;
            }

            /**
             * removeARO1FromList
             *
             * @param {array} adrList
             * @return {*}
             */
            function removeARO1FromList(adrList) {
                return adrList.filter((adr) => isARO3(adr));
            }

            /**
             * hideShowAdrTip
             */
            function hideShowAdrTip() {
                const adrTipLength = $('#adrTip').text().length;
                if (adrTipLength < 1) {
                    $('#adrTip').closest('i').hide();
                } else {
                    $('#adrTip').closest('i').show();
                }
            }

            /**
             * getUserType
             *
             * @param {object} user
             * @return {string|*}
             */
            function getUserType(user) {
                if (user) {
                    return user.accountType;
                }
                return '';
            }

            /**
             * loadCommonStrings
             */
            function loadCommonStrings() {
                const stringInfos = [
                    {key: 'messagePlace', dflt: ''},
                    {key: 'messageTime', dflt: ''},
                    {key: 'closedString', dflt: ''},
                    {key: 'backOrdered', dflt: ''},
                    {key: 'processing', dflt: ''},
                    {key: 'psvDist', dflt: ''},
                    {key: 'psvCust', dflt: ''},
                    {key: 'psvPfc', dflt: ''},
                    {key: 'psvAnon', dflt: ''},
                    {key: 'adrLabel', dflt: cartCfg.adrProgram},
                    {key: 'item', dflt: 'Item'},
                    {key: 'quantity', dflt: 'Quantity'},
                    {key: 'exclusiveOfferTitle', dflt: 'Exclusive Offer'},
                    {key: 'exclusiveOfferMessage', dflt: 'This product is only available to qualified users.'},
                    {key: 'signIn', dflt: 'Sign In'},
                    {key: 'learnMore', dflt: 'Learn More'},
                    {key: 'earlyAccessMessage', dflt: 'You have Early Access Items available to purchase or share! Promotion Ends July 23, 2019'},
                    {key: 'earlyAccessLink', dflt: 'Go See My Products'},
                    {key: 'earlyAccessModalTitle', dflt: 'Early Access Purchase'},
                    {key: 'earlyAccessModalMessage', dflt: 'You have been granted early access to some of our new items!'},
                    {key: 'earlyAccessModalButton', dflt: 'View Early Access Products'},
                    {key: 'qtyRedeemWithPoints', dflt: '{num} with points'}

                    // add the loyalty strings here
                ];

                const stringInfosKeys = stringInfos.map((s) => s.key);

                getStrings()
                    .then((allStrings) => {
                        // Omit all but the common strings
                        const fields = Object.entries(allStrings).filter(([key]) => stringInfosKeys.includes(key));
                        return Object.fromEntries(fields);
                    })
                    .catch((err) => {
                        return StringService.getStrings(stringInfos);
                    })
                    .then((strings) => {
                        apply(() => updateCommonStrings(strings));
                    });

                // StringService.getStrings(stringInfos).then((strings) => {
                //     apply(function() {
                //         updateCommonStrings(strings);
                //     });
                // });
            }

            /**
                 * This will add custom script and style tags in the context config to the page specified
                 * You need to add the following configs to your context config to your page
                 *
                 * custom${pageName}ScriptUrl
                 * custom${pageName}Script
                 * custom${pageName}StyleUrl
                 * custom${pageName}Styles
                 *
                 *  @param {string} pageName  Required
                 */
            function loadCustomJSStylesOnPage(pageName) {
                if (cartCfg.customCartScriptUrl) {
                    const scriptEle = document.createElement('script');
                    scriptEle.type = 'text/javascript';
                    scriptEle.setAttribute('src', cartCfg.customCartScriptUrl);
                    document.head.appendChild(scriptEle);
                }
                if (cartCfg.customCartScript) {
                    // Run the custom script
                    eval(cartCfg.customCartScript);
                }

                if (cartCfg.customCartStyleUrl) {
                    const styleEle = document.createElement('style');
                    styleEle.type = 'text/css';
                    styleEle.setAttribute('src', cartCfg.customCartStyleUrl);
                    document.head.appendChild(styleEle);
                }
                if (cartCfg.customCartStyles) {
                    const styleEle = document.createElement('style');
                    styleEle.type = 'text/css';
                    styleEle.appendChild(document.createTextNode(cartCfg.customCartStyles));
                    document.head.appendChild(styleEle);
                }
            }

            /**
             * updateCommonStrings
             *
             * @param {array} strings
             */
            function updateCommonStrings(strings) {
                const accountType = getUserType(user);

                for (const str in strings) {
                    if (Object.prototype.hasOwnProperty.call(strings, str)) {
                        $scope[str] = strings[str];
                    }
                }

                // These two strings are set differently because of HTML Rendering on the $scope variables in the HTML
                $scope.itemLabel = strings.item;
                $scope.quantityLabel = strings.quantity;

                // The processing string in adrStrings comes from common strings
                $scope.adrStrings = {
                    selectLabel: $scope.tdc.addToAdrSelectLabel,
                    buttonLabel: $scope.tdc.adrExistingTxt,
                    processingStr: strings.processing,
                    itemsStr: $scope.tdc.addToAdrItemsString,
                    programName: cartCfg.adrProgram
                };

                switch (accountType) {
                    case '10':
                        $scope.psvLabel = strings.psvDist;
                        break;
                    case '20':
                        $scope.psvLabel = strings.psvCust;
                        break;
                    case '30':
                        $scope.psvLabel = strings.psvPfc;
                        break;
                    default:
                        $scope.psvLabel = strings.psvAnon;
                        break;
                }
            }

            $scope.secondaryactionurl = UrlService.checkUrlForExtension($scope.tdc.exclusiveProductLearnMoreURL) || '';
            $scope.toastEvent = events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS;

            $scope.closeEarlyAccessModal = () => {
                QualificationService.setEarlyAccessQualificationModal(true);
                toggleEarlyAccessModal();
            };

            $scope.getExclusiveOfferPagePath = () => {
                if (cartCfg.exclusiveOfferAppLocation) {
                    const locale = `${RunConfigService.getRunConfig().language}_${RunConfigService.getRunConfig().country}`;
                    return cartCfg.exclusiveOfferAppLocation.replace('{locale}', locale);
                } else {
                    const nuskinMarket = runConfig.country === 'JP' ? 'markets' : 'nuskin';
                    const isMysite = $scope.useMySiteFooterAndHeader ? '.mysite' : '';
                    return `/content/${nuskinMarket}/${runConfig.language}_${runConfig.country}/exclusive-offer${isMysite}.html`;
                }
            };

            $scope.goToQualificationPage = () => {
                QualificationService.setEarlyAccessQualificationModal(true);
                window.location.href = $scope.getExclusiveOfferPagePath();
            };

            // if agelocme product then returns the agelocme code otherwise
            // it returns the sku
            $scope.getItemSkuCodeValue = (dispItem = {sku: ''}) => {
                return dispItem.agelocme ? dispItem.agelocme.code : dispItem.sku;
            };

            $scope.getCartBottomMessage = function() {
                return $sce.trustAsHtml($scope.tdc.cartBottomMessage);
            };

            /**
             * getCartBottomMessage
             *
             * @return {*}
             */
            $scope.getCartBottomMessage = function() {
                return $sce.trustAsHtml($scope.tdc.cartBottomMessage);
            };

            /**
             * Show Early Access Modal
             */
            async function toggleEarlyAccessModal() {
                $scope.showQualModal = !window.ReactNativeWebView &&
                                        (await QualificationService.getQualificationBanner()) &&
                                        !ShoppingContext.getShoppingContext() &&
                                        !(await QualificationService.getEarlyAccessQualificationModal());
                $scope.$apply();
            }

            /**
             * Show Early Access Banner
             */
            async function toggleEarlyAccessBanner() {
                $scope.hasQualification = !window.ReactNativeWebView &&
                                            !ShoppingContext.getShoppingContext() &&
                                            (await QualificationService.getQualificationBanner());
                $scope.$apply();
            }

            /**
             * inject the klarna messaging
             */
            function injectKlarnaMessage() {
                if ($scope.cartInfo.totalOrderPrice > 0) {
                    const amount = $filter('toCents')($scope.personalOfferDiscount
                        ? $scope.personalOfferDiscountedPrice
                        : $scope.cartInfo.loyaltyRewards
                            ? $scope.cartInfo.totalOrderPrice - $scope.cartInfo.loyaltyRewardPoints
                            : $scope.cartInfo.totalOrderPrice);
                    document.getElementById('klarna-cart-message').innerHTML = '<klarna-placement ' +
                        '                                data-key="credit-promotion-badge" ' +
                        `                                data-locale="${$scope.runConfig.language}-${$scope.runConfig.country}" ` +
                        `                                data-purchase-amount="${amount}"` +
                        '                            </klarna-placement>';
                }
            }

            /**
             * initListeners
             */
            function initListeners() {
                // since subscriptions remained from each time the controller
                //  is called unsubscribe needs to be called beforehand.

                events.unsubscribe(events.shop.PRODUCT_SEARCH_CHANGED);
                events.unsubscribe(events.shop.PRODUCT_SEARCH_FAILED);
                events.unsubscribe(events.shop.CHECK_USER_SAME);
                events.unsubscribe(events.shop.CART_ERROR_MSG);
                events.unsubscribe(events.shop.SPONSOR_SET);
                events.unsubscribe('solrSearchItemNotReleasedForSale');
                events.unsubscribe('solrSearchGeneralError');
                events.unsubscribe('cart-ready');

                // listens for cart update events to update the view of the cart.
                events.subscribe(events.shop.CART_UPDATED, (info) => {
                    if (info.add || info.remove || info.modify || info.removeAll) {
                        // Only clear the errors if the cart is actually changing
                        if ($scope.cartRady) {
                            $scope.error.clearErrors();
                        }
                    }
                    if (info.add) {
                        const addedItem = info.add.item;

                        $scope.dispItems.push(addedItem);
                        if (addedItem.productAvailableQty < addedItem.qty && !addedItem.isBusinessPortfolio && !addedItem.isAdr) {
                            $scope.error.errorMessages.push({
                                text: $scope.tdc.searchAtpErrorTxt.replace('{productName}', addedItem.title),
                                details: addedItem.hasAdrOption ? `addAsAdrLink:${addedItem.sku}` : undefined
                            });
                        }
                        if (util.MobileUtils.isMobile() && $scope.dispItems.length === 1) {
                            window.scrollTo(0, 0);
                        }
                    }
                    if (info.modify) {
                        const dispItem = $scope.dispItems.find((dispItem) => dispItem.key === info.modify.key);

                        if (dispItem) {
                            Object.assign(dispItem, info.modify.item);
                        }
                    }
                    if (info.remove) {
                        $scope.dispItems = $scope.dispItems.filter((dispItem) => dispItem.key != info.remove.key);
                        if (util.MobileUtils.isMobile() && $scope.dispItems.length === 0) {
                            window.scrollTo(0, 0);
                        }
                    }
                    if (info.removeAll) {
                        $scope.dispItems = [];
                    }
                    updateCartInfo(info.cartInfo);
                    $scope.calculateLoyaltyMaxRedeemAmount();
                    apply();
                });

                events.subscribe(events.shop.CHECK_USER_SAME, function() {
                    checkUser();
                });

                events.subscribe(events.shop.PRODUCT_SEARCH_CHANGED, function() {
                    apply($scope.error.clearErrors());
                });

                events.subscribe(events.shop.PRODUCT_SEARCH_FAILED, function() {
                    $scope.error.clearErrors();
                    $scope.error.addErrorMessage('error', {text: $scope.tdc.searchFailedTxt});
                });

                events.subscribe(events.shop.CART_ERROR_MSG, function(errorData) {
                    if (errorData.clearErrors) {
                        $scope.error.clearErrors();
                    }
                    if (errorData.error) {
                        $scope.error.addErrorMessage('error', {text: errorData.error});
                    }
                    if (errorData.info) {
                        $scope.error.addErrorMessage('info', {text: errorData.info});
                    }
                });

                events.subscribe(events.shop.SPONSOR_SET, () => {
                    $scope.storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor();
                    $scope.distributorImage = $scope.storefrontSponsor && $scope.storefrontSponsor.siteLogo ? $scope.storefrontSponsor.siteLogo : '';
                    apply();
                });

                events.subscribe('solrSearchItemNotReleasedForSale', (productTitle) => {
                    apply(
                        events.publish(events.shop.CART_ERROR_MSG, {error: $scope.tdc.searchAtpErrorTxt.replace('{productName}', productTitle)})
                    );
                });

                events.subscribe('solrSearchGeneralError', (error) => {
                    apply(
                        events.publish(events.shop.CART_ERROR_MSG, {error: $scope.tdc.unableToAddToCart || $scope.tdc.searchFailedTxt})
                    );
                });

                events.getValue(events.shop.CART_SYNCED_ON_LOAD, (status) => {
                    if (status === true) {
                        $scope.cartReady = true;
                        $scope.dispItems = CartService.getItemData();
                        $scope.cartInfo = CartService.getCartInfo();
                        $scope.error = ErrorMessageCookieService.getErrorMessages();
                        ErrorMessageCookieService.resetErrorMessagesStorage();

                        // sets hasAdrItems and hasOrderItems which are used for loyalty
                        updateCartInfo(CartService.getCartInfo());

                        // COM-2043: GA Checkout Step 1 to fire after adding item to cart
                        publishCartCheckoutEvent(1, $scope.dispItems);

                        $scope.showCartSpinner = false;

                        apply();
                    }
                }, true);

                events.getValue(events.mobile.NATIVE_INITIALIZING, (status) => {
                    if (typeof status === 'boolean') {
                        $scope.nativeInitializing = status;
                    }
                }, true);
            }

            /**
             * Helper function to build and populate publish event object.
             * COM-2043 New GA Events - Checkout Steps 1 and 2
             *
             * Event is Fired on:
             * PageLoad - Load Cart (Step 1)
             * Remove Product - Delete Line Item from Cart (Step 1) - removeProductClicked()
             * Add Product - Add a new Line Item to Cart (Step 1) - addSearchProductCallback()
             * Inc. Qty - Inc. qty of existing sku (Step 1) - incrementQty()
             * Dec. Qty - Dec. qty of existing sku (Step 1) - decrementQty()
             * On Click of Purchase Now Btn (Step 2) - gotoNextPage()
             *
             * @param {*} stepNumber - Step Number of Checkout Event
             * @param {*} cartItems - [] of cart Items
             */
            function publishCartCheckoutEvent(stepNumber, cartItems) {
                // COM-2043: GA Checkout Step @param:stepNumber to fire on cart page
                events.publish(events.shop.CART_CHECKOUT, {
                    'ecommerce': {
                        'currencyCode': $scope.currencyCode,
                        'checkout': {
                            'actionField': {'step': stepNumber},
                            'products': cartItems.map((item) => {
                                return {
                                    'name': item.title,
                                    'id': item.sku,
                                    'price': item.price,
                                    'promoPrice': item.promoPrice,
                                    'psv': item.psv,
                                    'quantity': item.qty
                                };
                            })
                        }
                    }
                });
            }

            /**
             * updateCartInfo
             *
             * @param {object} cartInfo
             */
            function updateCartInfo(cartInfo) {
                $scope.hasAdrItems = $scope.hasOrderItems = false;
                $scope.dispItems.forEach((dispItem) => {
                    $scope.hasAdrItems = $scope.hasAdrItems || dispItem.isAdr;
                    $scope.hasOrderItems = $scope.hasOrderItems || (!dispItem.isAdr && !$scope.excludedBusFolioSkus.some((sku) => sku === dispItem.sku));
                });

                if (cartInfo) {
                    $scope.cartInfo = cartInfo;
                }

                // Show personal offer discount in cart totals
                $scope.personalOfferDiscount = false;
                if ($scope.isPersonalOffer) {
                    // Don't manipulate cart totals if distributor or preferred customer
                    if (!user || (user && user.accountType !== '10' && user.accountType !== '30')) {
                        const discountMultiplier = $scope.personalOffer.discount ? $scope.personalOffer.discount.multiplier : 1;
                        $scope.personalOfferDiscountedPrice = $scope.cartInfo.totalOrderPrice * discountMultiplier;
                        if ($scope.cartInfo.totalOrderPrice > $scope.personalOfferDiscountedPrice) {
                            $scope.personalOfferDiscount = true;
                        }
                    }
                }
            }

            const addPayPalText = async () => {
                if (cartCfg.enablePayPalText) {
                    // PayPal payment text URL
                    $scope.payPalTextUrl = '';
                    const response = await axios({
                        method: 'get',
                        url: `${UrlService.getAwsUrl()}/PaymentPaypal/v1/client-id/${runConfig.country}`,
                        headers: {
                            client_id: runConfig.clientId
                        }});

                    const payPalScritElem = document.createElement('script');
                    payPalScritElem.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${response.data.data.clientId}&components=messages`);
                    document.head.appendChild(payPalScritElem);
                }
            };

            addPayPalText();

            updateCartInfo(CartService.getCartInfo());
            loadCommonStrings();
            checkForDowntime();
            initListeners();
            if (!cartCfg.showEventAdrFlow) {
                getAdrs(user);
            }
            showAdrOverrideInfo();
            CartService.checkProductLanguages();
            CartService.setSignupMode();

            if (runConfig.assessmentApp) {
                $('#mobile-processing').hide();
                sessionStorage.removeItem('appChangeSpinner');
            }

            if (RunConfigService.getRunConfig().country !== 'TW') {
                if (AuthenticationService.isLoggedIn()) {
                    toggleEarlyAccessModal();
                    const showBanner = await QualificationService.getQualificationBanner();
                    // If showBanner is false or true then we have already called getQualifications just check for null or undefined
                    if (showBanner === undefined || showBanner === null) {
                        QualificationService.getQualifications().then((response) => {
                            toggleEarlyAccessBanner();
                            toggleEarlyAccessModal();
                            apply();
                        });
                    }

                    const earlyAccessLink = document.getElementById('earlyAccessLink');
                    if (earlyAccessLink) {
                        earlyAccessLink.href = $scope.getExclusiveOfferPagePath();
                        toggleEarlyAccessBanner();
                    }
                } else {
                    toggleEarlyAccessBanner();
                }

                events.subscribe(events.shop.QUALIFICATION_SENT, function(data) {
                    toggleEarlyAccessBanner();
                    toggleEarlyAccessModal();
                });
            }
        };

        await initHeader();
        if (!window.ReactNativeWebView) {
            await initCart();
        } else {
            let cartInited = false;
            events.getValue(events.mobile.NATIVE_INITIALIZING, async (status) => {
                if (status === false && !cartInited) {
                    cartInited = true;
                    await initCart();
                }
            }, true);
        }
    }
]);
